import {IState} from './ManualRefinement.types';

export const initializeState:IState = {
    classes: [],
    index: -1,
    manualImages: [],
    referenceImages: [],
    isMoveToAnotherClass: false,
    isCleanClick: false,
    isErrorPage: false,
    allProjectClasses: []
};

export const initializeStateJson = JSON.stringify(initializeState);
